import {
  Button,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Paper,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import React, { useCallback, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/auth';
import { useNotification } from '../../contexts/notification';
import ColorModeIconDropdown from '../../themes/MuiTheme/ColorModeIconDropdown';

export default function LoginForm() {
  const theme = useTheme();

  const navigate = useNavigate();
  const { signIn, signInWithGoogle, signInWithFacebook } = useAuth();
  const [loading, setLoading] = useState(false);

  const { setNotification } = useNotification();

  const formData = useRef({ email: '', password: '', rememberMe: false });

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      const { email, password } = formData.current;
      setLoading(true);

      const result = await signIn({ email, password });

      if (!result.isOk) {
        setLoading(false);
        setNotification({
          open: true,
          message: result.message,
          severity: 'error',
        });
        if (result.noSubscription) {
          navigate('/subscribe');
        }
      } else {
        setLoading(false);
        setNotification({
          open: true,
          message: 'Sikeres belépés!',
          severity: 'success',
        });
      }
    },
    [signIn, setNotification]
  );

  const onGoogleLogin = useCallback(
    async (e) => {
      e.preventDefault();
      const { email, password } = formData.current;
      setLoading(true);

      const result = await signInWithGoogle();

      if (!result.isOk) {
        setLoading(false);
        setNotification({
          open: true,
          message: result.message,
          severity: 'error',
        });
        if (result.noSubscription) {
          navigate('/subscribe');
        }
      } else {
        setLoading(false);
        setNotification({
          open: true,
          message: 'Sikeres belépés!',
          severity: 'success',
        });
      }
    },
    [signIn, setNotification]
  );

  const onSubscribeClick = useCallback(() => {
    navigate('/subscribe');
  }, [navigate]);

  return (
    <Paper
      elevation={3}
      variant='highlight'
      sx={{ padding: 3, maxWidth: 700, margin: '5% auto' }}
    >
      <div style={{ position: 'fixed', top: 30, right: 30 }}>
        <ColorModeIconDropdown size='medium' />
      </div>
      <Typography variant='subtitle1' textAlign='center' sx={{ mb: 2 }}>
        Ha már tagunk vagy lépj be a feliratkozáskor megadott módon.
      </Typography>
      <form onSubmit={onSubmit}>
        <FormControl fullWidth margin='normal'>
          <TextField
            label='E-mail cím'
            type='email'
            variant='filled'
            required
            onChange={(e) => (formData.current.email = e.target.value)}
            disabled={loading}
            autoComplete='email'
          />
        </FormControl>
        <FormControl fullWidth margin='normal'>
          <TextField
            label='Jelszó'
            type='password'
            variant='filled'
            required
            onChange={(e) => (formData.current.password = e.target.value)}
            disabled={loading}
            autoComplete='current-password'
          />
        </FormControl>
        <Typography textAlign='center'>
          <Link to='/reset-password'>
            Elfelejtetted a jelszavad? Kattints ide vagy lépj be valamelyik
            közösségi oldal segítségével!
          </Link>
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              onChange={(e) => (formData.current.rememberMe = e.target.checked)}
              disabled={loading}
            />
          }
          label='Jegyezz meg ezen a gépen'
        />
        <Button
          type='submit'
          variant='contained'
          color='primary'
          fullWidth
          disabled={loading}
          sx={{ m: 1 }}
        >
          {loading ? (
            <CircularProgress size={24} />
          ) : (
            'Belépés e-mail cím és jelszó segítésgével'
          )}
        </Button>

        <Button
          variant='contained'
          color='primary'
          startIcon={
            <img
              src={
                theme.palette.mode === 'dark'
                  ? './img/3rdparty/web_dark_rd_na.svg'
                  : './img/3rdparty/web_light_rd_na.svg'
              }
              alt='Google logo'
              style={{ width: 24, height: 24 }}
            />
          }
          fullWidth
          disabled={loading}
          sx={(theme) => {
            return {
              m: 1,
              backgroundColor: '#FFFFFF',
              '&:hover': { backgroundColor: '#747775' },
              color: '#000000',
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '16px',
              padding: '10px 20px',
              ...theme.applyStyles('dark', {
                color: '#FFFFFF',
                backgroundColor: '#131314',
                '&:hover': { backgroundColor: '#8E918F' },
              }),
            };
          }}
          onClick={onGoogleLogin}
        >
          Belépés Google fiókkal
        </Button>
        {/*  <Button
          variant='contained'
          color='primary'
          startIcon={
            <img
              src={'./img/3rdparty/Facebook_Logo_Primary.png'}
              alt='Facebook logo'
              style={{ width: 24, height: 24 }}
            />
          }
          fullWidth
          disabled={loading}
          sx={(theme) => {
            return {
              m: 1,
              backgroundColor: '#4267b2',
              '&:hover': { backgroundColor: '#4267b2' },

              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '16px',
              padding: '10px 20px',
              ...theme.applyStyles('dark', {
                backgroundColor: '#4267b2',
                '&:hover': { backgroundColor: '#4267b2' },
              }),
            };
          }}
          onClick={signInWithFacebook}
        >
          Belépés Facebook fiókkal
        </Button> */}
        <Button
          variant='outlined'
          color='secondary'
          fullWidth
          onClick={onSubscribeClick}
          disabled={loading}
          sx={{ m: 1 }}
        >
          Ha még nem vagy tagunk válassz egy csomagot és iratkozz fel!
        </Button>
        <Typography textAlign='center' sx={{ mt: 2 }}>
          <Link to='/'>Visszalépés</Link>
        </Typography>
      </form>
    </Paper>
  );
}
